import { useState } from 'react';

const useFileState = () => {
  const [fileUploadInfo, setFileUploadInfo] = useState([]);
  const [filesToAttach, setFilesToAttach] = useState([]);
  const [s3FileInfo, setS3FileInfo] = useState([]);
  const [allS3FileIds, setAllS3FileIds] = useState([]);
  const [griffinFileInfo, setGriffinFileInfo] = useState([]);
  const [s3EsignFileInfo, setS3EsignFileInfo] = useState([]);
  const [fileData, setFileData] = useState(null);
  const [isFileDataFromInput, setIsFileDataFromInput] = useState(false);

  const getFileUploadInfo = (fileInfo, setIsSubmitButtonDisable) => {
    if (fileInfo.length === 0) {
      setFileUploadInfo([]);
      setIsSubmitButtonDisable(true);
    } else {
      setFileUploadInfo(fileInfo);
      setIsSubmitButtonDisable(false);
    }
  };

  /* eslint-disable max-len -- need */
  const createFile = (blob, fileName) => {
    const file = new File([blob], fileName, { lastModified: new Date().getTime(), type: blob.type });
    setFileData(file);
  };
  /* eslint-enable max-len -- need */

  const fileSubmit = (file, setIsSubmitButtonDisable) => {
    setFileData(file);
    setIsFileDataFromInput(true);
    if (file) {
      setIsSubmitButtonDisable(false);
    } else {
      setIsSubmitButtonDisable(true);
    }
  };

  return {
    fileUploadInfo,
    setFileUploadInfo,
    filesToAttach,
    setFilesToAttach,
    s3FileInfo,
    setS3FileInfo,
    allS3FileIds,
    setAllS3FileIds,
    griffinFileInfo,
    setGriffinFileInfo,
    s3EsignFileInfo,
    setS3EsignFileInfo,
    fileData,
    setFileData,
    isFileDataFromInput,
    setIsFileDataFromInput,
    getFileUploadInfo,
    createFile,
    fileSubmit,
  };
};

export default useFileState;
